var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 41 50",
    width: 41,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.617 19.6l-1.094 1.18 4.976 4.495c1.17 1.062 1.84 2.558 1.84 4.127v19.574h1.623V29.4c-.002-2.017-.86-3.94-2.368-5.305L32.617 19.6zM26.167 1H5.07c-2.24.003-4.054 1.8-4.057 3.998v39.98c.003 2.207 1.818 3.995 4.057 3.998h20.285v-1.43a17.99 17.99 0 0 1 3.109-10.119.79.79 0 0 0-.101-1.009l-5.68-5.597c-.525-.518-.803-1.23-.767-1.96a2.58 2.58 0 0 1 .96-1.877c1.106-.833 2.67-.714 3.633.276l8 7.893 1.147-1.13-5.442-5.364V4.998C30.22 2.8 28.406 1.003 26.167 1zM28.6 27.055l-.944-.93a4.42 4.42 0 0 0-5.813-.38c-.927.75-1.5 1.853-1.548 3.035a4.16 4.16 0 0 0 1.241 3.169l5.217 5.14c-1.946 3.1-3 6.65-3.015 10.285H5.07c-1.344 0-2.434-1.074-2.434-2.4v-2.4H22.92v-1.6H2.636V7.397H28.6v19.658zm0-21.257H2.636v-.8c0-1.324 1.1-2.4 2.434-2.4h21.097c1.344 0 2.434 1.074 2.434 2.4v.8z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 15.392h3.246c.896 0 1.623-.716 1.623-1.6v-3.198c0-.883-.726-1.6-1.623-1.6H22.1c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198H22.1v-3.198zM5.88 23.388h3.246c.896 0 1.623-.716 1.623-1.6V18.6c0-.883-.726-1.6-1.623-1.6H5.88c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198H5.88v-3.2z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 15.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.996 23.388h3.246c.896 0 1.623-.716 1.623-1.6V18.6c0-.883-.726-1.6-1.623-1.6h-3.246c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198h-3.246v-3.2zm8.104 4.797h3.246c.896 0 1.623-.716 1.623-1.6V18.6c0-.883-.726-1.6-1.623-1.6H22.1c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198H22.1v-3.2z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 15.992
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 23.988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 23.988
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M5.88 15.392h3.246c.896 0 1.623-.716 1.623-1.6v-3.198c0-.883-.726-1.6-1.623-1.6H5.88c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198H5.88v-3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M13.996 15.392h3.246c.896 0 1.623-.716 1.623-1.6v-3.198c0-.883-.726-1.6-1.623-1.6h-3.246c-.896 0-1.623.716-1.623 1.6v3.198c0 .883.726 1.6 1.623 1.6zm0-4.797h3.246v3.198h-3.246v-3.198z"
  }))));
}

export default __webpack_public_path__ + "media/3147cde5.svg";
export { SvgGoogle as ReactComponent };